import { Categories } from '@gumtree/shared/src/types/client-data';
import { overrideWithCustomDataSets } from '../get-data/transform/filters-dictionary';
import type { FiltersDictionary } from '../types';

export const UPDATE_FILTERS_DICTIONARY = 'UPDATE_FILTERS_DICTIONARY';

export const updateFiltersDictionary = (
    filters: Partial<FiltersDictionary>,
    categories: Categories
) => ({
    type: UPDATE_FILTERS_DICTIONARY,
    payload: { filters, categories },
});

export default (
    state = {} as FiltersDictionary,
    action: ReturnType<typeof updateFiltersDictionary>
): FiltersDictionary =>
    action.type === UPDATE_FILTERS_DICTIONARY
        ? {
              ...state,
              ...Object.fromEntries(
                  Object.entries(action.payload.filters)
                      .map(([key, value]) => [key, { ...state[key], ...value }])
                      .map(([key, value]) =>
                          overrideWithCustomDataSets([key, value], action.payload.categories)
                      )
              ),
          }
        : state;
